import { RuntimeModules, StaticLogger, _keys } from '@nu-art/ts-common';
const getItem = (dbKey, itemId) => {
    const module = RuntimeModules().filter(module => module.dbDef?.dbKey === dbKey)[0];
    if (!module) {
        StaticLogger.logWarning(`Could not get module for dbKey ${dbKey}`);
        return;
    }
    const item = module.cache.unique(itemId);
    if (!item)
        StaticLogger.logWarning(`Could not get item for dbKey ${dbKey} and id ${itemId}`);
    return item;
};
export const calculateConflictResolutionTree = (dependencies) => {
    const checkedItemIds = _keys(dependencies.dependencyMap);
    return {
        type: 'root',
        alwaysExpanded: true,
        item: {},
        _children: checkedItemIds.map(id => calculateConflictResolutionTree_CheckedItem(dependencies.dependencyMap, id, dependencies.dbKey)),
    };
};
const calculateConflictResolutionTree_CheckedItem = (dependencyMap, itemId, dbKey) => {
    const conflictingCollectionKeys = _keys(dependencyMap[itemId]);
    const item = getItem(dbKey, itemId);
    return {
        type: 'checkedItem',
        item: { itemId, dbKey, item },
        alwaysExpanded: false,
        _children: conflictingCollectionKeys.map(dbKey => calculateConflictResolutionTree_ConflictingCollection(dbKey, dependencyMap[itemId][dbKey])),
    };
};
const calculateConflictResolutionTree_ConflictingCollection = (dbKey, conflictingItemIds) => {
    return {
        type: 'conflictingCollection',
        item: { dbKey },
        alwaysExpanded: false,
        _children: conflictingItemIds.map(id => calculateConflictResolutionTree_ConflictingItem(dbKey, id))
    };
};
const calculateConflictResolutionTree_ConflictingItem = (dbKey, itemId) => {
    const item = getItem(dbKey, itemId);
    return {
        type: 'conflictingItem',
        item: { dbKey, itemId, item },
        alwaysExpanded: false,
    };
};
//# sourceMappingURL=tree-calculation.js.map